export default (kasko) => {
  const itemsToNameMapping = {
    item_5994788bf965810034710f40159: 'hausratsversicherung',
    item_5a3905dc363122c6e5c8474e212: 'privathaftversicherung',
    item_584a39bbf525ae7e16872650e69: 'gebäudeversicherung',
    item_957711384345569b02c8ad7cc7a: 'hausratsversicherung, privathaftversicherung',
    item_18127b9f3c3ade0df4330aa9bd8: 'privathaftversicherung, gebäudeversicherung',
    item_5991be0f8150e87e8663b49d2ac: 'hausratsversicherung, gebäudeversicherung',
    item_7e644b3be4c54b18c53e7138511: 'produktkombinationen',
  };

  kasko.addEventListener(
    'state-changed',
    (isEmailModal) => {
      const { item_id } = kasko.getState('input');
      const {
        extraData: { yearly_gross_premium, yearly_building_gross_premium } = {},
      } = kasko.getState('quote.data') || {};

      if (isEmailModal && window.dataLayer) {
        window.dataLayer.push({
          event: 'offer_start_confirmation_directa',
          directa_type: itemsToNameMapping[item_id],
          // If building item selected then use building_gross_premium
          value: yearly_building_gross_premium || yearly_gross_premium,
          offer_type: 'directa_quote',
        });
      }
    },
    { slice: 'input.is_email_modal' },
  );
};
